import 'slick-carousel';

const initProductsSlider = (element) => {
	let $slider = element;
	const maxSlides = parseInt($slider.closest('.slider').data('slides'), 10) || 4;

	if ($slider.length === 0 && $slider.find('> *').length >= maxSlides) {
		return;
	}

	$slider.slick({
		slidesToShow: maxSlides,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: true,
		prevArrow: $slider.closest('.slider').find('.slider__prev'),
		nextArrow: $slider.closest('.slider').find('.slider__next'),
		responsive: [
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					adaptiveHeight: true
				}
			}
		]
	});
}

export default initProductsSlider;

/**
 * Each all elements with .js-slider class
 */
$('.js-slider .slider__slides').each(function(index, el) {
	const $this = $(this);
	const isSliderInActiveTab = $this.closest('.tab').length > 0 && ! $this.closest('.tab').hasClass('is-current');

	if (isSliderInActiveTab) {
		return;
	}

	initProductsSlider($this);
});

/**
 * Listen for changes done in the Theme Editor
 */
$(document).on('shopify:section:load', function(event) {
	if (event.detail.sectionId === 'products-slider') {
		$('.js-slider .slider__slides').each(function(index, el) {
			const $this = $(this);

			if ($this.hasClass('slick-initialized')) {
				return;
			}

			initProductsSlider($this);
		});
	}
});
